import {
  closeMidasPanel,
  useMidasEnabled,
  useMidasPanelOpen
} from 'hooks/useMidas'
import MidasLauncher, { resetLauncherBounce } from './MidasLauncher'
import MidasPanel from './MidasPanel'

// Midas launcher + chat panel. Renders nothing unless the `midas_enabled` flag
// and the Midas config both say enabled.
export default function Midas() {
  const { enabled, config } = useMidasEnabled()
  const open = useMidasPanelOpen()

  if (!enabled || !config) return null

  return (
    <>
      <MidasLauncher hidden={open} />
      <MidasPanel open={open} onClose={closeMidasPanel} config={config} />
    </>
  )
}

// Test hook: lets each test see the first-appearance bounce afresh.
export function resetMidasLauncherForTests(): void {
  resetLauncherBounce()
  closeMidasPanel()
}
